import { render, staticRenderFns } from "./Piano.vue?vue&type=template&id=53722991"
import script from "./Piano.vue?vue&type=script&lang=ts"
export * from "./Piano.vue?vue&type=script&lang=ts"
import style0 from "./Piano.vue?vue&type=style&index=0&id=53722991&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports